module.exports = __webpack_public_path__ + "static/media/simplify.5dfcb33e.png";